import React from "react";
function Our() {
  return (
    <div className="bg-color-header h-20 flex items-center justify-center text-color-mine text-lg">
      Designed by Vignesh | Contact - 9751205230
    </div>
  );
}

export default Our;
